import type {
  GetTokens,
  NorafUpdates,
  NorafUpdatesIgnoreListItem,
} from './types';
import type {Schemas} from './dto.generated';
import {exceptionToPromiseReject} from './exceptionToPromiseReject';
import {httpDelete, httpGet, httpPost} from './http/ebba';
import {mapNorafUpdatePageResponse} from './mappers/mapNorafUpdate';
import {mapNorafUpdatesIgnoreList} from './mappers/mapNorafUpdateIgnoreListItem';

export const getNorafUpdates = (
  getTokens: GetTokens,
  page?: number,
  size?: number,
  sort?: string,
  mock?: boolean,
): Promise<NorafUpdates> => {
  return exceptionToPromiseReject(() =>
    httpGet<Schemas.NorafUpdatesPageResponse>({
      subdir: 'noraf/updates',
      queryParams: {
        page: page !== undefined ? page : undefined,
        size,
        sort: sort ? sort : 'lastUpdated,asc',
      },
      getTokens,
      mock,
    }).then(mapNorafUpdatePageResponse),
  );
};

export const deleteNorafUpdate = (
  getTokens: GetTokens,
  id: string,
  mock?: boolean,
): Promise<void> => {
  return exceptionToPromiseReject(() =>
    httpDelete({
      subdir: 'noraf/updates/{id}',
      subdirParams: {id},
      getTokens,
      mock,
    }),
  );
};

export const deleteNorafUpdateByAgentId = (
  getTokens: GetTokens,
  agentId: string,
  mock?: boolean,
): Promise<void> => {
  return exceptionToPromiseReject(() =>
    httpDelete({
      subdir: 'noraf/updates/agent/{agentId}',
      subdirParams: {agentId},
      getTokens,
      mock,
    }),
  );
};

export const postNorafUpdatesIgnorelist = (
  getTokens: GetTokens,
  nationalId: string,
  agentId: string,
  name: string,
  mock?: boolean,
): Promise<void> => {
  return exceptionToPromiseReject(() =>
    httpPost<void, Schemas.NorafUpdatesIgnoreListItem>({
      subdir: 'noraf/updates/ignorelist',
      body: {
        nationalId,
        agentId,
        name,
      },
      getTokens,
      mock,
    }).then(() => undefined),
  );
};

export const getNorafUpdatesIgnorelist = (
  getTokens: GetTokens,
  mock?: boolean,
): Promise<NorafUpdatesIgnoreListItem[]> => {
  return exceptionToPromiseReject(() =>
    httpGet<Schemas.NorafUpdatesIgnoreListResponse>({
      subdir: 'noraf/updates/ignorelist',
      getTokens,
      mock,
    }).then(mapNorafUpdatesIgnoreList),
  );
};

export const deleteNorafUpdateIgnorelistItem = (
  getTokens: GetTokens,
  id: string,
  mock?: boolean,
): Promise<void> => {
  return exceptionToPromiseReject(() =>
    httpDelete({
      subdir: 'noraf/updates/ignorelist/{id}',
      subdirParams: {id},
      getTokens,
      mock,
    }),
  );
};
